import React from 'react';
import {Loader} from 'rsuite';
import cn from 'classnames';


import styles from './LoaderCentered.module.scss';

interface ILoaderCenteredProps {
    active: boolean,
}

const LoaderCentered: React.FC<ILoaderCenteredProps> = ({active}) => {

    if (!active) {
        return <></>;
    }

    return (
        <div className={cn(
            styles.wrapper,
            styles.color,
        )}>
            <Loader/>
        </div>
    );
};

export default LoaderCentered;